module.exports = __webpack_public_path__ + "media/field_goal_right.69e29db5.mp4";